import React from "react";

import { useLabels, usePrefetchLabels } from "../../../hooks/useLabels";

import { IconButton } from "../../icon-button";

import { Header } from "../header";

import { labels as removeConfirmDialogLabels } from "../../photo-selection-screen/remove-confirm-dialog/labels";
import { labels } from "./labels";

function SelectionHeaderLeft({
	onBack,
	nbrOfSelectedPhotos,
}: {
	onBack(): void;
	nbrOfSelectedPhotos: number;
}) {
	const [[selectPhotosLabel]] = useLabels([labels.selectPhotos]);

	// Prefetch labels for when Remove button is clicked
	usePrefetchLabels(Object.values(removeConfirmDialogLabels));

	return (
		<>
			<IconButton iconName="cross" onClick={() => onBack()} />

			<span className="photo-selection-screen__header-number">
				{nbrOfSelectedPhotos || selectPhotosLabel}
			</span>
		</>
	);
}

function SelectionHeaderRight({
	onRemove,
	isRemoveDisabled,
}: {
	onRemove(): void;
	isRemoveDisabled: boolean;
}) {
	const [[removeLabel]] = useLabels([labels.remove]);

	return (
		<IconButton
			iconName="bin"
			title={removeLabel}
			onClick={onRemove}
			disabled={isRemoveDisabled}
		/>
	);
}

export function SelectionHeader({
	onBack,
	onRemove,
	nbrOfSelectedPhotos,
}: {
	onBack(): void;
	onRemove(): void;
	nbrOfSelectedPhotos: number;
}) {
	return (
		<Header
			left={<SelectionHeaderLeft onBack={onBack} nbrOfSelectedPhotos={nbrOfSelectedPhotos} />}
			right={
				<SelectionHeaderRight
					onRemove={onRemove}
					isRemoveDisabled={nbrOfSelectedPhotos <= 0}
				/>
			}
		/>
	);
}
